export default "__VITE_ASSET__Dg5qJXt7__"